export default __webpack_public_path__ + "media/8359e8fd6d404dcaf16c2cfbea8af7e14106f2e03980aa2fec208e049e3fd3a0.svg";